// Pure weekly-focus-goal logic. No DB, no DOM — unit-tested.

// Sunday (local) of the week containing `date`, as YYYY-MM-DD.
export function currentWeekStart(date = new Date()) {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  d.setDate(d.getDate() - d.getDay()); // getDay(): 0 = Sunday
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Progress from distinct check-in dates vs the target day count.
export function goalProgress(goal, checkins = []) {
  const target = Math.max(1, Number(goal?.target_days) || 1);
  const days = new Set((checkins || []).map((c) => c.date)).size;
  return { days, target, done: days >= target, pct: Math.min(100, Math.round((days / target) * 100)) };
}

// One check-in per calendar day.
export function canCheckInToday(checkins = [], todayISO) {
  return !(checkins || []).some((c) => c.date === todayISO);
}
